import PropTypes from "prop-types"
import React from "react"
import "stylesheets/ScorePage/Score.scss"
import { PILLAR_ENVIRONMENTAL } from "utils/constants/pillars"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"

const ITDomainAnalysisLayoutOrganism = ({
  maturity,
  chart1,
  chart2,
  chart3,
  chart4,
  chart5,
  chart6,
  forceMaturity,
}) => {
  const pillarId = PILLAR_ENVIRONMENTAL

  return (
    <ScoreLayoutOrganism
      forceMaturity={forceMaturity}
      maturity={maturity}
      pillarId={pillarId}
      chart1={<>{chart1}</>}
      chart2={<>{chart2}</>}
      chart3={<>{chart3}</>}
      chart4={<>{chart4}</>}
      chart5={<>{chart5}</>}
      chart6={<>{chart6}</>}
    />
  )
}

ITDomainAnalysisLayoutOrganism.propTypes = {
  maturity: PropTypes.number,
  chart1: PropTypes.element.isRequired,
  chart2: PropTypes.element.isRequired,
  chart3: PropTypes.element.isRequired,
  chart4: PropTypes.element.isRequired,
  chart5: PropTypes.element.isRequired,
  chart6: PropTypes.element.isRequired,
  forceMaturity: PropTypes.bool,
}

ITDomainAnalysisLayoutOrganism.defaultProps = {
  maturity: null,
  forceMaturity: false,
}

export default ITDomainAnalysisLayoutOrganism
